module.exports = __webpack_public_path__ + "static/img/appIOS1.379d467.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/appInstavice/appIOS1.png
// module id = XNld
// module chunks = 1